export const DEV_TEST_COMPANIES = ['FA-38264', '52-57403', 'F7-52113','8D-66054', '8A-56702', '65-41407', '88-42217', '38-87613', '69-87305',
	'94-52553', 'F9-26586', 'FF-81574', '26-46164', '11-67773', 'FF-81574', '3E-65108', '36-21165', '83-30206',
	'21-24324', '00-44342', 'ED-21660', '2A-37634', '6E-58866', '99-45474', '18-63453', '34-32278', '28-14347',
	'EE-68250', '7A-56005', '64-50271', '8C-47143', 'CB-56448', '67-64531', '27-76637', '5B-28554', '76-35016', '12-28778',
	'32-76634', '8B-25845', '8F-25711', '07-14645', '91-84641', 'A4-72868', 'DA-60445', '4E-50845', 'AA-50411', 'EE-74747', '41-13671', 'E8-20714', '8D-85713', '9F-53313']

export const END2END_TEST_COMPANIES = [
	'FA-38264', '9C-52844', 'A0-56553', '34-32278', '99-45474', '7B-60122', '18-63453',
	'30-24051', '8B-25845', '2E-58123', '08-66147', '96-15215', '8F-25711', '07-14645', 'A4-72868', 'DA-60445', '91-84641']

export const LIVE_TEST_COMPANIES = ['7E-67147', 'FA-38264', '34-12483', 'D3-50576', '3E-11548', '18-11110', '3E-41313', '3F-61834', '08-26463', '6F-66557', 'B2-75225', '2B-57683', '47-10650', '25-47744', '4D-01327']

export const blockedDealerNumbers = ['2B-35781', 'DE-55563']
